import ContentComponent from "./ContentComponent";

export default ContentComponent;